import { DeleteConfirmationDialog } from '@/components/delete-confirmation-dialog'

import type { Customer } from '@/types'

interface ArchiveCustomerDialogsProps {
  /** The customer to archive from a row or panel menu, or null when closed. */
  customer: Customer | null
  onCancelSingle: () => void
  onConfirmSingle: (customer: Customer) => void
  singlePending: boolean
  /** Ids picked in the bulk bar, or null when closed. */
  bulkIds: string[] | null
  onCancelBulk: () => void
  onConfirmBulk: (ids: string[]) => void
  bulkPending: boolean
}

/* Confirmations for archiving one customer or a selection. Archiving is the
   backend's restorable soft delete, so the copy says what actually happens
   (hidden, online login closed, history kept, restorable) — not "cannot be
   undone". */
export function ArchiveCustomerDialogs({
  customer, onCancelSingle, onConfirmSingle, singlePending,
  bulkIds, onCancelBulk, onConfirmBulk, bulkPending,
}: ArchiveCustomerDialogsProps) {
  return (
    <>
      <DeleteConfirmationDialog
        open={!!bulkIds}
        onOpenChange={(open) => { if (!open) onCancelBulk() }}
        title="Archive customers"
        description={
          bulkIds
            ? <>Archive <strong>{bulkIds.length}</strong> selected customers? They leave the directory and can&apos;t sign in online. Their history is kept and you can restore them from Archived.</>
            : null
        }
        confirmLabel="Archive"
        onConfirm={() => { if (bulkIds) onConfirmBulk(bulkIds) }}
        isPending={bulkPending}
      />

      <DeleteConfirmationDialog
        open={!!customer}
        onOpenChange={(open) => { if (!open) onCancelSingle() }}
        title="Archive customer"
        description={
          customer
            ? <>Archive <strong>{customer.firstName} {customer.lastName}</strong>? They leave the directory and can&apos;t sign in online. Their orders and points are kept and you can restore them from Archived.</>
            : null
        }
        confirmLabel="Archive"
        onConfirm={() => { if (customer) onConfirmSingle(customer) }}
        isPending={singlePending}
      />
    </>
  )
}
